import { computed, inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs/operators';

import { I18nService } from '@recruitee/i18n';

import { OfferAssignmentsActions } from './features/offer-assignments/data/store/offer-assignments.store';
import { programSelectors } from './features/program/data/store/program.store';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly title = inject(Title);
  private readonly i18n = inject(I18nService);
  private readonly translations: { [key: string]: string } = {
    profile: 'rtr.page_title.profile',
    referrals: 'rtr.page_title.referrals',
    jobs: 'rtr.page_title.jobs',
    offer: 'rtr.page_title.offer',
    form: 'rtr.page_title.make_referral',
    welcome: 'rtr.page_title.how_it_works',
  };
  private programData = this.store.selectSignal(programSelectors.data);
  private companyName = computed(() => this.programData()?.companyName);

  public updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (!title || !this.translations[title]) {
      this.title.setTitle(this.companyName()!);
      return;
    }

    if (title === 'offer') {
      this.actions$
        .pipe(
          ofType(OfferAssignmentsActions.fetchOneSuccess),
          take(1),
          map(action => action.payload.data.offer.title),
        )
        .subscribe(offerTitle => {
          this.title.setTitle(
            this.i18n.translate(this.translations.offer, {
              companyName: this.companyName(),
              offerTitle,
            }),
          );
        });
    } else {
      this.title.setTitle(
        this.i18n.translate(this.translations[title], {
          companyName: this.companyName(),
        }),
      );
    }
  }
}
